import React, {useCallback, useState} from "react";
import {TextField} from "features/components/text-field";
import {Icon} from "features/components/icon";
import "./index.scss";

function PasswordTextField(props) {
    const [type, setType] = useState("password");
    const toggleType = useCallback(() => {
        setType(type === "password" ? "text" : "password");
    }, [type]);
    const isVisible = type === "text";
    return <div className={"password-text-field"}>
        <TextField type={type} {...props} />
        <span className={"btn-eye"} onClick={toggleType}><Icon>{isVisible ? "eye-off" : "eye"}</Icon></span>
    </div>
}
export default PasswordTextField;